import AuthStore from "@/store/modules/AuthStore";

export default class RaceFilterUtils {
  public static filterCategories(all: any[] = []) {
    const result = [];
    for (const v of all ?? []) {
      if (
        v.edadMinima > AuthStore.getPersonaEdad ||
        v.edadMaxima < AuthStore.getPersonaEdad
      ) {
        continue;
      }
      if (
        v.tipoParticipante === "T" ||
        AuthStore.getPersonaSexo === v.tipoParticipante
      ) {
        result.push(v);
      }
    }

    return result;
  }

  public static filterDistances(all: any[] = []) {
    const result = [];
    for (const v of all ?? []) {
      if (
        v.edadMinima > AuthStore.getPersonaEdad ||
        v.edadMaxima < AuthStore.getPersonaEdad
      ) {
        continue; // ignorados por no cumplir
      } else {
        result.push(v);
      }
    }
    return result;
  }
}
